import React from "react";
import { connect } from "react-redux";
import Flagship from "../../core/flagship";
import * as appActions from "../../actions/appActions";
import { Button, Divider } from "semantic-ui-react";
import { bindActionCreators } from "redux";
import "../../styles/loginForm.scss";
import Field from "../misc/Field";
import { randomPassword } from "../../utils/helpers";

class Setup extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.username = this.props.routeParams.splat;
    this.token = this.props.location.query.token || false;
    this.state = {
      password: randomPassword(),
      passwordVisible: true,
      changed: false,
      validInvitation: null
    };
    this.saveUser = this.saveUser.bind(this);
  }

  componentDidMount() {
    document.title = "Account Setup";

    let self = this;

    if (self.token !== false) {
      Flagship.get(
        "check-setup-token/" + this.username,
        {
          invite_token: self.token
        },
        function(response) {
          if (response.data.success !== true) {
            self.setState({
              validInvitation: false
            });
            Flagship.error(
              "Your invitation is invalid or has expired.",
              self.props.routeParams.splat,
              self.props.userId
            );
          } else {
            self.setState({
              validInvitation: true
            });
          }
        },
        function(err) {
          self.setState({
            validInvitation: false
          });
          Flagship.error(
            "Couldn't validate token: " + err,
            self.props.routeParams.splat,
            self.props.userId
          );
        }
      );
    } else {
      self.setState({
        validInvitation: false
      });
    }
  }

  onChangePassword(e, value) {
    this.setState({
      password: value
    });
  }

  saveUser() {
    let self = this;

    Flagship.post(
      "setup-user/" + this.username,
      {
        invite_token: self.token,
        new_password: self.state.password
      },
      function(response) {
        if (response.data.success === true) {
          Flagship.notify("Password set!", "success");
          self.props.actions.login({
            username: self.username,
            password: self.state.password
          });
        } else {
          Flagship.error(
            "Could not set password.",
            self.props.routeParams.splat,
            self.props.userId
          );
        }
      },
      null,
      true
    );
  }

  render() {
    if (this.state.validInvitation === null) {
      return (
        <div id="login-form" className="fade-in">
          <div id="login-form-inner" className={"animated headShake"}>
            <h1>Flagship</h1>
            <div className="white-text">Checking token, please wait...</div>
          </div>
        </div>
      );
    } else if (this.state.validInvitation === true) {
      if (this.props.route.mode === "reset") {
        return (
          <div id="login-form" className="fade-in">
            <div id="login-form-inner" className={"animated headShake"}>
              <h1>Flagship</h1>
              <h2 className="white-text">Password Reset</h2>
              <p className="login-message">
                Please set your new password below.
              </p>

              <Field
                type="password"
                validation="password"
                value={this.state.password || ""}
                visible={this.state.passwordVisible}
                placeholder="Password can't be empty"
                onChange={(e, value) => this.onChangePassword(e, value)}
              />

              <Divider />

              <Button primary onClick={this.saveUser}>
                Save and Login
              </Button>
            </div>
          </div>
        );
      } else {
        return (
          <div id="login-form" className="fade-in">
            <div id="login-form-inner" className={"animated headShake"}>
              <h1>Flagship</h1>
              <h2 className="white-text">Welcome Aboard!</h2>
              <p className="login-message">
                You've been invited to join the new version of Flagship. <br />
                To set sail, first create your password below.
              </p>

              <Field
                type="password"
                validation="password"
                value={this.state.password || ""}
                visible={this.state.passwordVisible}
                placeholder="Password can't be empty"
                onChange={(e, value) => this.onChangePassword(e, value)}
              />

              <Divider />

              <Button primary onClick={this.saveUser}>
                Save and Login
              </Button>
            </div>
          </div>
        );
      }
    } else {
      return (
        <div id="login-form" className="fade-in">
          <div id="login-form-inner" className={"animated headShake"}>
            <h1>Flagship</h1>
            <div className="white-text">
              The invitation to set your password is invalid or expired.
            </div>
          </div>
        </div>
      );
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(appActions, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(Setup);



// WEBPACK FOOTER //
// ./src/components/views/Setup.js